import { Injectable } from '@angular/core';
import { URL_API } from '../global/config';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IFichaResumen } from '../models/IFichaResumen';

@Injectable({
  providedIn: 'root'
})
export class ReporteGeneralFichaService {

  private _urlEndpoint: string = URL_API.UrlApiSisCatalogacion+'/api_cata/v1/reportecatalogacionfichas/resumen';
  private _httpHeaders = new HttpHeaders({'Content-Type': 'application/json'});


constructor(
  private _http: HttpClient
) { }

  traerReporteGeneralFicha(nroFicha: string): Observable<IFichaResumen>{
    return this._http.get(this._urlEndpoint+'/'+nroFicha).pipe(
      map( response => response as IFichaResumen)
    )
  }
}
